import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
// eslint-disable-next-line spire/fenced-imports
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import * as React from "react";
import { css } from "styled-components"; 

const enum fields {
    website = "website"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.website]: string;
    };
}

export interface FooterStyles {
    page?: MobiusPageProps;
}

export const footerStyles: FooterStyles = {
    page: {
        css: css`
                min-height: 460px; 
               .linksContainerWrapper {
                opacity: 1;
                background-color: ${COLORS.background.lightGrey};
                padding: 40px 0 30px 20px;
                clip-path: polygon(0% 10%, 5% 0%, 100% 0%, 100% 5%, 100% 100%, 100% 100%, 5% 100%, 0 100%);
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            null,
                        ],
                        "minMax",
                    )}
            }
            .footerInnerWrapper {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            background: ${COLORS.background.lightGrey};
                        `,
                        css`
                            background: ${COLORS.background.lightGrey};
                        `,
                        css`
                            background: ${COLORS.background.lightGrey};
                        `,
                        css`
                            padding-left: 10px;
                        `,
                        null,
                    ])}
                > div[class^="GridOffset"] {
                    >div[class^="griditemstyle"]: first-child {
                        position: relative;
                        z-index: 1;
                        background-color: ${COLORS.background.base};
                        &:after {
                            content: "";
                            position: absolute;
                            left: -500%;
                            z-index: 0;
                            width: 500%;
                            height: 100%;
                            background-color: ${COLORS.background.base};
                        }
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        opacity: 1;
                                        background-color: ${COLORS.background.lightGrey};
                                        padding-bottom: 30px;
                                        clip-path: polygon(
                                            0% 10%,
                                            15% 0%,
                                            100% 0%,
                                            100% 5%,
                                            100% 100%,
                                            100% 100%,
                                            5% 100%,
                                            0 100%
                                        );
                                    `,
                                    css`
                                        opacity: 1;
                                        background-color: ${COLORS.background.lightGrey};
                                        padding-bottom: 30px;
                                        clip-path: polygon(
                                            0% 10%,
                                            15% 0%,
                                            100% 0%,
                                            100% 5%,
                                            100% 100%,
                                            100% 100%,
                                            5% 100%,
                                            0 100%
                                        );
                                    `,
                                    css`
                                        opacity: 1;
                                        background-color: ${COLORS.background.lightGrey};
                                        padding-bottom: 30px;
                                        clip-path: polygon(
                                            0% 20%,
                                            10% 0%,
                                            100% 0%,
                                            100% 5%,
                                            100% 100%,
                                            100% 100%,
                                            5% 100%,
                                            0 100%
                                        );
                                    `,
                                    css`
                                        padding: 40px;
                                    `,
                                ],
                                "minMax",
                            )}
                    }
                    > div[class^="GridItemStyle"]:nth-child(2) {
                        background: ${COLORS.background.base};
                    }
                }
            }
            .footerLeftLinkList {
                span {
                    opacity: 1;
                    color: ${COLORS.secondaryNavyThree};
                    font-family: ${TYPOGRAPHY.fontFamily.base};
                    font-size: ${TYPOGRAPHY.size.smallest};
                    font-weight: ${TYPOGRAPHY.weight.base};
                    font-style: normal;
                    letter-spacing: ${TYPOGRAPHY.letterSpacing.smallest};
                    text-align: left;
                    line-height: ${TYPOGRAPHY.lineHeight.smallest};
                    text-transform: capitalize;
                }
            }
            .footerSocialLinks {
                > div[class^="GridOffset"] {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    text-align: center;
                                    justify-content: center;
                                `,
                                css`
                                    text-align: center;
                                    justify-content: center;
                                `,
                                css`
                                    text-align: center;
                                    justify-content: center;
                                `,
                                null,
                            ],
                            "minMax",
                        )}
                    div[class^="GridItemStyle"] {
                        flex-basis: 12%;
                        max-width: 12%;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        flex-basis: 5%;
                                        max-width: 5%;
                                    `,
                                    null,
                                ],
                                "minMax",
                            )}
                    }
                }
            }
            .logoWrapperClass {
                .home-page-link {
                    width: 100%;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    justify-content: center;
                                `,
                                css`
                                    justify-content: center;
                                `,
                                css`
                                    justify-content: center;
                                `,
                                null,
                            ],
                            "minMax",
                        )}

                    img {
                        object-fit: contain;
                        object-position: bottom;
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                text-align: center;
                                justify-content: center;
                            `,
                            css`
                                text-align: center;
                                justify-content: center;
                            `,
                            css`
                                text-align: center;
                                justify-content: center;
                            `,
                            null,
                        ],
                        "minMax",
                    )}
            }
            .footerLeftLinkList {
                .list-wrapper {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    text-align: center;
                                `,
                                css`
                                    text-align: center;
                                `,
                                css`
                                    text-align: center;
                                `,
                                null,
                            ],
                            "minMax",
                        )}
                }
                .title-wrapper {
                    display: none;
                }
            }
            .footerSubLinkWrapper {
                padding-bottom: 20px;
                > div[class^="GridOffset"] {
                    > div[class^="GridItemStyle"] {
                        flex-basis: 22%;
                        max-width: 22%;
                        padding: 0 15px 20px;
                        position: relative;
                    }
                    div[class^="GridItemStyle"]:last-child {
                        flex-basis: 34%;
                        max-width: 34%;
                        > div[class^="Wrapper"] {
                            .list-wrapper::after {
                                background-color: transparent;
                            }
                        }
                    }
                }
            }
            .subWrapper {
                padding-bottom: 0;
                > div[class^="GridOffset"] {
                    > div[class^="GridItemStyle"] {
                        flex-basis: 22%;
                        max-width: 22%;
                        > div[class^="Wrapper"] {
                            .list-wrapper::after {
                                height: 100px;
                            }
                        }
                    }
                    div[class^="GridItemStyle"]:nth-child(3) {
                        > div[class^="Wrapper"] {
                            .list-wrapper::after {
                                background-color: transparent;
                            }
                        }
                    }
                    div[class^="GridItemStyle"]:last-child {
                        flex-basis: 34%;
                        max-width: 34%;
                    }
                }
            }
            .copyrightClass {
                min-height: 100px;
                max-width: 100%;
                background-color: ${COLORS.darkGrey};
                p {
                    opacity: 0.8;
                    color: ${COLORS.secondaryNavyThree};
                    font-size: ${TYPOGRAPHY.size.smallest};
                    font-weight: 400;
                    font-style: normal;
                    letter-spacing: ${TYPOGRAPHY.letterSpacing.smallest};
                    text-align: center;
                    padding: 15px 0;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    padding: 15px 50px;
                                `,
                                css`
                                    padding: 15px 50px;
                                `,
                                css`
                                    padding: 15px 50px;
                                `,
                                null,
                            ],
                            "minMax",
                        )}
                }
            }
        `,
    },
};
const styles = footerStyles;

const Footer = ({ id, fields }: PageProps & OwnProps) => (
    <Page as="footer" fullWidth={[true, true, true, true, true]} isFooter={true} {...styles.page}>
        <Zone contentId={id} zoneName="Content" />
        {fields.website === "tecumseh" && <Zone contentId={id} zoneName="tecumseh-popup-zone" />}
        {fields.website === "masterflux" && <Zone contentId={id} zoneName="masterflux-popup-zone" />}
    </Page>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
        fieldDefinitions: [
            {
                name: "website",
                editorTemplate: "DropDownField",
                defaultValue: "",
                fieldType: "General",
                options: [
                    {
                        value: "tecumseh",
                        displayName: "tecumseh",
                    },
                    {
                        value: "masterflux",
                        displayName: "masterflux",
                    }
                ],
                hideEmptyOption: true,
            }
        ]
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
